import { render, staticRenderFns } from "./u-back-top.vue?vue&type=template&id=2c0de5ee&scoped=true&"
import script from "./u-back-top.vue?vue&type=script&lang=js&"
export * from "./u-back-top.vue?vue&type=script&lang=js&"
import style0 from "./u-back-top.vue?vue&type=style&index=0&id=2c0de5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0de5ee",
  null
  
)

export default component.exports